import BaseRepository from './base.repository';

class SymptomRepository extends BaseRepository {
  constructor() {
    super('/symptoms');
  }

  find(conditions) {
    return this.client.get('', conditions);
  }
}

export default new SymptomRepository();
